export default "__VITE_ASSET__cpqAAjOv__"